import { Reveal } from "./shared";

const STEPS = [
  { n: "01", title: "Enquire", body: "Tell us your team size, location, and preferred dates. We'll recommend the right session format." },
  { n: "02", title: "We come to you", body: "A doctor arrives at your office with all the training equipment — manikins, AEDs, the lot." },
  { n: "03", title: "Train together", body: "Your team learns by doing — CPR, defibrillator use, and choking response in 60-minute sessions." },
  { n: "04", title: "Confidence that sticks", body: "No certificates gathering dust — your people leave with the confidence to actually act." },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="px-4 pt-24 pb-10 sm:px-6 lg:px-8" data-testid="how-it-works-section">
    <div className="mx-auto max-w-7xl">
      <Reveal className="mx-auto max-w-3xl text-center">
        <h2 className="font-display text-3xl font-bold tracking-tight text-[#14231B] sm:text-4xl lg:text-5xl">
          Simple from <span className="text-[#1E7B4F]">start to finish</span>
        </h2>
        <p className="mt-4 text-lg text-[#5F6E63]">
          No travel, no fuss. We handle the kit and the teaching, so your team can focus on learning.
        </p>
      </Reveal>
      <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.08} className="h-full">
            <div className="h-full rounded-3xl border border-[#E7E3D9] bg-white p-8 shadow-sm hover:shadow-md transition-shadow duration-300">
              <p className="font-display text-5xl font-extrabold text-[#1E7B4F]/20">{s.n}</p>
              <h3 className="mt-4 font-display text-xl font-semibold text-[#14231B]">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-[#5F6E63]">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
